import { useCallback } from 'react';
import { Stack } from '@optimus-web/core';
import { useAPI } from '@mews/framework';
import { useCommanderThunkDispatch } from '@mews-commander/utils';
import { searchArticles } from '../actions';
import { KnowledgeArticleList } from './KnowledgeArticleList';

interface Props {
    searchToken: string;
}

export const SearchArticleList = ({ searchToken }: Props) => {
    const dispatch = useCommanderThunkDispatch();
    const call = useCallback(async () => dispatch(searchArticles(searchToken)), [dispatch, searchToken]);
    const { data, isLoading } = useAPI(call, { articles: [] });

    return (
        <Stack spacing="200" vertical>
            {data.articles ? <KnowledgeArticleList articles={data.articles} isLoading={isLoading} /> : null}
        </Stack>
    );
};
